/* eslint-disable */
import $ from 'jquery';
import _ from 'underscore';
import ko from 'knockout';
var urlRegex = new RegExp('^(http|https)(://)(.+)', 'i');
var ViewModel = function (options) {
  this.maxFullUrlLength = options.maxFullUrlLength || 2048;
  this.protocols = [{
    Value: 'https',
    Text: 'https://'
  }, {
    Value: 'http',
    Text: 'http://'
  }];
  if (!options.inputProtocol && options.url && options.url.indexOf('http') !== 0) {
    options.url = 'https://' + options.url;
  }
  this.errorContainer = ko.observable('');
  this.errorMessage = ko.observable('');
  this.showErrors = ko.observable(false);
  this.protocol = ko.observable();
  this.urlWithoutProtocol = ko.observable();
  this.fullUrl = ko.computed({
    read: function () {
      if (!this.urlWithoutProtocol() || _.isEmpty(this.urlWithoutProtocol().trim())) {
        return null;
      }
      if (options.inputProtocol) {
        return this.protocol() + this.urlWithoutProtocol();
      }
      var regexResult = urlRegex.exec(this.urlWithoutProtocol().trim());
      if (regexResult) {
        this.protocol(regexResult[1]);
        this.urlWithoutProtocol(regexResult[3]);
      }
      var value = this.protocol() + '://' + this.urlWithoutProtocol().trim();
      return value;
    },
    write: function (value) {
      if (options.inputProtocol) {
        var inputUriRegex = /^(\S+:(\/\/)?)(\S+)/;
        var regexResult = inputUriRegex.exec(value);
        this.protocol(regexResult ? regexResult[1] : 'https://');
        this.urlWithoutProtocol(regexResult ? regexResult[3] : '');
      } else {
        var regexResult = urlRegex.exec(value);
        this.protocol(regexResult ? regexResult[1] : 'https');
        this.urlWithoutProtocol(regexResult ? regexResult[3] : '');
      }
    }
  }, this);
  this.errorContainer(options.errorContainer);
  this.fullUrl(options.url);
  this.isDisabled = ko.observable(options.disabled || options.readOnly);
  this.maxLength = ko.computed(function () {
    return this.maxFullUrlLength - this.protocol().length - ('://').length;
  }, this);
  this.hasErrors = ko.observable(false);
};
export default ViewModel;

